module.exports = BVBanners;